export default "__VITE_ASSET__DeRnN_aB__"